import {IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {BsEnvelope, BsEnvelopeOpen, BsEyeFill} from "react-icons/bs";
import PersianNumberFormat from "../../helper/PersianNumberFormat";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import FileCell from "../system/fileViewer";
import {updateNotificationRead} from "../../services/notification/notification";
import {TableHead} from "../system/thead";
import React, {useContext, useState} from "react";
import TableTdContent from "../system/tableTdContent";
import {PaginateContext} from "../../context/paginate";
import {NotificationContext} from "../../context/notification";
import {UpdateHeaderContext} from "../../context/update_header";


const TABLE_HEAD = ["#", "عنوان", "توضیحات", "فایل", "زمان ارسال", "وضعیت", "عملیات"];

export function NotificationGrid() {

  const {
    notifications,
    setModalOpen,
    setNotification,
    setNotifications,
  } = useContext(NotificationContext)

  const {
    sortBy,
    setSortBy,
    sortType,
    setSortType,
    rowsCount,
    active,
    setTotalRows
  } = useContext(PaginateContext)

  const {setUpdateNotifications} = useContext(UpdateHeaderContext)

  const notificationRead = async (id) => {
    const data = {
      id: id,
    };

    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(rowsCount),
      "offset": (parseInt(active) - 1) * parseInt(rowsCount),
    }).toString()

    let result;

    result = await updateNotificationRead(data, paginate);

    if (result.status === 202) {
      const {notificationList, total_count} = result.data;
      setNotifications(notificationList)
      setTotalRows(total_count)
      setUpdateNotifications(Date.now)
    }
  };

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "عنوان": "title",
    "توضیحات": "description",
    "فایل": "attachment",
    "زمان ارسال": "description",
    "وضعیت": "status",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "عنوان": true,
    "توضیحات": true,
    "فایل": false,
    "زمان ارسال": true,
    "وضعیت": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {notifications.map(
          ({id, title, description, attachment, create_date, push_status}, index) => {
            const isLast = index === notifications.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>
                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>
                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(title)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <TableTdContent content={description} length={60}/>
                </td>

                <td className={classes}>
                  {attachment &&
                    <div className="flex justify-center">
                      <FileCell fileCode={attachment}/>
                    </div>
                  }
                  {!attachment &&
                    <Typography color="blue-gray" className="textRight">
                      -
                    </Typography>

                  }
                </td>
                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {PersianNumberFormat(create_date)}
                    </Typography>
                  </div>
                </td>
                <td className={classes}>
                  <div className="flex justify-center ">
                    {push_status === 'unread' &&
                      <Tooltip content="خوانده شد">
                        <IconButton variant="text" className="text-align=right" onClick={() => {
                          notificationRead(id)
                        }}>
                          <BsEnvelope size={30}/>
                        </IconButton>
                      </Tooltip>
                    }
                    {push_status === 'read' &&
                      <BsEnvelopeOpen size={30}/>}
                  </div>
                </td>
                <td className={classes}>
                  <Tooltip content="مشاهده">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setNotification(notifications[index]);
                      setModalOpen(true);
                    }}>
                      <BsEyeFill className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}